import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-3" }
const _hoisted_2 = { class: "mt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link active",
      id: "zairyou-tab",
      "data-toggle": "tab",
      "aria-selected": "true",
      href: "#zairyou-panel",
      role: "tab",
      "aria-controls": "zairyou-panel"
    }, "材料費")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "kyuyo-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#kyuyo-panel",
      role: "tab",
      "aria-controls": "kyuyo-panel"
    }, "給与費")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "itaku-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#itaku-panel",
      role: "tab",
      "aria-controls": "itaku-panel"
    }, "委託費")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "keihi-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#keihi-panel",
      role: "tab",
      "aria-controls": "keihi-panel"
    }, "経費")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "uriage-genka-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#uriage-genka-panel",
      role: "tab",
      "aria-controls": "uriage-genka-panel"
    }, "売上原価")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "other-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#other-panel",
      role: "tab",
      "aria-controls": "other-panel"
    }, "その他事業費用")
  ])
], -1)
const _hoisted_4 = { class: "tab-content" }
const _hoisted_5 = {
  class: "tab-pane fade show active",
  id: "zairyou-panel",
  role: "tabpanel",
  "aria-labelledby": "zairyou-tab"
}
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = { class: "mt-3 float-right" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  class: "tab-pane fade",
  id: "kyuyo-panel",
  role: "tabpanel",
  "aria-labelledby": "kyuyo-tab"
}
const _hoisted_10 = { class: "mt-3" }
const _hoisted_11 = { class: "mt-3 float-right" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  class: "tab-pane fade",
  id: "itaku-panel",
  role: "tabpanel",
  "aria-labelledby": "itaku-tab"
}
const _hoisted_14 = { class: "mt-3" }
const _hoisted_15 = { class: "mt-3 float-right" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  class: "tab-pane fade",
  id: "keihi-panel",
  role: "tabpanel",
  "aria-labelledby": "keihi-tab"
}
const _hoisted_18 = { class: "mt-3" }
const _hoisted_19 = { class: "mt-3 float-right" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  class: "tab-pane fade",
  id: "uriage-genka-panel",
  role: "tabpanel",
  "aria-labelledby": "uriage-genka-tab"
}
const _hoisted_22 = { class: "mt-3" }
const _hoisted_23 = { class: "mt-3 float-right" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  class: "tab-pane fade",
  id: "other-panel",
  role: "tabpanel",
  "aria-labelledby": "other-tab"
}
const _hoisted_26 = { class: "mt-3" }
const _hoisted_27 = { class: "mt-3 float-right" }
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kaikei_kijun_setting_title = _resolveComponent("kaikei-kijun-setting-title")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_jigyouhi_setting_item = _resolveComponent("jigyouhi-setting-item")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, { loading: _ctx.loading }, {
    header: _withCtx(() => [
      _createVNode(_component_kaikei_kijun_setting_title, { "main-title": "事業費用明細表" })
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_loading_button, {
          color: "primary",
          loading: _ctx.loading,
          disabled: !_ctx.isAllValid,
          onClick: _ctx.onClickRegister
        }, {
          default: _withCtx(() => [
            _createTextVNode("登録")
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])
      ]),
      _createVNode(_component_response_result_alert, {
        class: "mt-3",
        "is-succeed": _ctx.isSucceedRequest,
        "error-message": _ctx.requestError,
        onDismiss: _ctx.onDismissAlert
      }, null, 8, ["is-succeed", "error-message", "onDismiss"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zairyouhiItems, (item, index) => {
                return (_openBlock(), _createBlock(_component_jigyouhi_setting_item, {
                  key: item.item.id,
                  item: item,
                  "is-first": index === 0,
                  "is-last": index === (_ctx.zairyouhiItems.length - 1),
                  onUpItem: _cache[0] || (_cache[0] = (v) => _ctx.upItem('Zairyouhi', v)),
                  onDownItem: _cache[1] || (_cache[1] = (v) => _ctx.downItem('Zairyouhi', v)),
                  onTrashItem: _cache[2] || (_cache[2] = (v) => _ctx.trashItem('Zairyouhi', v)),
                  onChangeInput: _cache[3] || (_cache[3] = (v) => _ctx.onChangeInput('Zairyouhi', v))
                }, null, 8, ["item", "is-first", "is-last"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addItem('Zairyouhi'))),
                disabled: _ctx.zairyouhiItems.length >= 10
              }, "項目を追加", 8, _hoisted_8)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kyuyohiItems, (item, index) => {
                return (_openBlock(), _createBlock(_component_jigyouhi_setting_item, {
                  key: item.item.id,
                  item: item,
                  "is-first": index === 0,
                  "is-last": index === (_ctx.kyuyohiItems.length - 1),
                  onUpItem: _cache[5] || (_cache[5] = (v) => _ctx.upItem('Kyuyohi', v)),
                  onDownItem: _cache[6] || (_cache[6] = (v) => _ctx.downItem('Kyuyohi', v)),
                  onTrashItem: _cache[7] || (_cache[7] = (v) => _ctx.trashItem('Kyuyohi', v)),
                  onChangeInput: _cache[8] || (_cache[8] = (v) => _ctx.onChangeInput('Kyuyohi', v))
                }, null, 8, ["item", "is-first", "is-last"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addItem('Kyuyohi'))),
                disabled: _ctx.kyuyohiItems.length >= 10
              }, "項目を追加", 8, _hoisted_12)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itakuhiItems, (item, index) => {
                return (_openBlock(), _createBlock(_component_jigyouhi_setting_item, {
                  key: item.item.id,
                  item: item,
                  "is-first": index === 0,
                  "is-last": index === (_ctx.itakuhiItems.length - 1),
                  onUpItem: _cache[10] || (_cache[10] = (v) => _ctx.upItem('Itakuhi', v)),
                  onDownItem: _cache[11] || (_cache[11] = (v) => _ctx.downItem('Itakuhi', v)),
                  onTrashItem: _cache[12] || (_cache[12] = (v) => _ctx.trashItem('Itakuhi', v)),
                  onChangeInput: _cache[13] || (_cache[13] = (v) => _ctx.onChangeInput('Itakuhi', v))
                }, null, 8, ["item", "is-first", "is-last"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addItem('Itakuhi'))),
                disabled: _ctx.itakuhiItems.length >= 10
              }, "項目を追加", 8, _hoisted_16)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keihiItems, (item, index) => {
                return (_openBlock(), _createBlock(_component_jigyouhi_setting_item, {
                  key: item.item.id,
                  item: item,
                  "is-first": index === 0,
                  "is-last": index === (_ctx.keihiItems.length - 1),
                  onUpItem: _cache[15] || (_cache[15] = (v) => _ctx.upItem('Keihi', v)),
                  onDownItem: _cache[16] || (_cache[16] = (v) => _ctx.downItem('Keihi', v)),
                  onTrashItem: _cache[17] || (_cache[17] = (v) => _ctx.trashItem('Keihi', v)),
                  onChangeInput: _cache[18] || (_cache[18] = (v) => _ctx.onChangeInput('Keihi', v))
                }, null, 8, ["item", "is-first", "is-last"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.addItem('Keihi'))),
                disabled: _ctx.keihiItems.length >= 10
              }, "項目を追加", 8, _hoisted_20)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uriageGenkaItems, (item, index) => {
                return (_openBlock(), _createBlock(_component_jigyouhi_setting_item, {
                  key: item.item.id,
                  item: item,
                  "is-first": index === 0,
                  "is-last": index === (_ctx.uriageGenkaItems.length - 1),
                  onUpItem: _cache[20] || (_cache[20] = (v) => _ctx.upItem('UriageGenka', v)),
                  onDownItem: _cache[21] || (_cache[21] = (v) => _ctx.downItem('UriageGenka', v)),
                  onTrashItem: _cache[22] || (_cache[22] = (v) => _ctx.trashItem('UriageGenka', v)),
                  onChangeInput: _cache[23] || (_cache[23] = (v) => _ctx.onChangeInput('UriageGenka', v))
                }, null, 8, ["item", "is-first", "is-last"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.addItem('UriageGenka'))),
                disabled: _ctx.uriageGenkaItems.length >= 10
              }, "項目を追加", 8, _hoisted_24)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherItems, (item, index) => {
                return (_openBlock(), _createBlock(_component_jigyouhi_setting_item, {
                  key: item.item.id,
                  item: item,
                  "is-first": index === 0,
                  "is-last": index === (_ctx.otherItems.length - 1),
                  onUpItem: _cache[25] || (_cache[25] = (v) => _ctx.upItem('Other', v)),
                  onDownItem: _cache[26] || (_cache[26] = (v) => _ctx.downItem('Other', v)),
                  onTrashItem: _cache[27] || (_cache[27] = (v) => _ctx.trashItem('Other', v)),
                  onChangeInput: _cache[28] || (_cache[28] = (v) => _ctx.onChangeInput('Other', v))
                }, null, 8, ["item", "is-first", "is-last"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary",
                onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.addItem('Other'))),
                disabled: _ctx.otherItems.length >= 10
              }, "項目を追加", 8, _hoisted_28)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}